import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ project, resource }) =>
    present(
      repository
        .getTasks(project, resource)
        .then((tasks) => ({ tasks, project, resource }))
        .catch(() => Promise.reject({ project, resource })),
    );
}

export type { Interactor };

export { createInteractor };
